import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withI18n, withI18nProps } from '@lingui/react'
import { push } from 'react-router-redux'
import compose from 'lodash/fp/compose'

import urlFor from 'shared/tools/url-helper'
import {
  getShowcaseAttributes,
  getRootNavigation,
  getShowcaseSections,
  getShowcaseHierarchy,
  getShowcaseFrom,
} from 'client/bookmate/selectors/showcase-selectors'
import { getShowcaseLink } from 'client/bookmate/helpers/showcase-helpers'
import errorBoundary from 'client/shared/decorators/error-boundary'

import ShowcaseContent from 'client/bookmate/blocks/showcase-content'

import { State as AppState } from 'client/shared/reducers/app-reducer'
import { Dispatch, State } from 'shared/types/redux'
import {
  ShowcaseSection,
  ShowcaseAttributes,
  TabProps,
  Navigation,
} from 'client/shared/types/showcase'
import { HierarchyProps } from 'client/shared/types/topic'
import { Location } from 'client/shared/types/react-router'
import { Exact } from 'types/local/exact-check'
import { DECE } from '../pages/kids-showcase'

type Props = Exact<withI18nProps> & {
  app: AppState
  dispatch: Dispatch
  attributes: ShowcaseAttributes
  sectionSlug?: string
  sections: {
    items: ShowcaseSection[]
    loading: boolean
  }
  rootNavigation: {
    language: string
    items: Navigation[]
    loading: boolean
  }
  hierarchy: HierarchyProps[]
  location: Location
  libraryLang: string
  load: () => void
  loadSectionsFrom: number | null | undefined
  userId: number
}

class KidsContentBox extends Component<Props> {
  prepareTabs(): TabProps[] {
    const {
      rootNavigation,
      attributes: { contentType, slug },
      app,
    } = this.props

    if (rootNavigation.items.length === 0) return []

    return rootNavigation.items.map(item => ({
      link: getShowcaseLink(
        item.params.content_type,
        item.params.slug,
        app.storedQuery,
      ),
      title: item.title,
      active: contentType
        ? item.params.content_type === contentType
        : item.params.slug === slug,
    }))
  }

  handleSearchFocus = () => {
    this.props.dispatch(push(urlFor.search(this.props.app.storedQuery)))
  }

  render(): JSX.Element {
    const {
      libraryLang,
      app,
      sections,
      dispatch,
      load,
      loadSectionsFrom,
      userId,
      sectionSlug,
    } = this.props
    const tabs = this.prepareTabs()

    return (
      <ShowcaseContent
        isKids
        sectionSlug={sectionSlug}
        userId={userId}
        app={app}
        dispatch={dispatch}
        tabs={tabs}
        sections={sections}
        navigation={{ items: [], loading: false }}
        libraryLang={libraryLang}
        attributes={{ language: 'sr', slug: DECE, contentType: 'mixed' }}
        handleSearchFocus={this.handleSearchFocus}
        load={load}
        loadSectionsFrom={loadSectionsFrom}
      />
    )
  }
}

const connectWrapper = connect(
  (state: State, ownProps: { currentSlug: string }) => ({
    app: state.app,
    libraryLang: state.currentUser.data.library_lang,
    rootNavigation: getRootNavigation(state),
    attributes: getShowcaseAttributes(state, ownProps.currentSlug),
    sections: getShowcaseSections(state, ownProps.currentSlug),
    hierarchy: getShowcaseHierarchy(state, ownProps.currentSlug),
    loadSectionsFrom: getShowcaseFrom(state, ownProps.currentSlug),
    userId: state.currentUser.data.id,
  }),
)

const wrappers = compose(
  connectWrapper,
  errorBoundary,
  withI18n({ update: true }),
)

export default wrappers(KidsContentBox)
